var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBigSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-727.000000, -2503.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/big/search",
    transform: "translate(727.000000, 2503.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1715729,66.8284271 C55.6094757,65.26633 55.6094757,62.73367 57.1715729,61.1715729 C58.73367,59.6094757 61.26633,59.6094757 62.8284271,61.1715729 L78.8284271,77.1715729 C80.3905243,78.73367 80.3905243,81.26633 78.8284271,82.8284271 C77.26633,84.3905243 74.73367,84.3905243 73.1715729,82.8284271 L57.1715729,66.8284271 Z",
    id: "Path-2",
    fill: "#C2C0CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,64 C55.045695,64 64,55.045695 64,44 C64,32.954305 55.045695,24 44,24 C32.954305,24 24,32.954305 24,44 C24,55.045695 32.954305,64 44,64 Z M44,72 C28.536027,72 16,59.463973 16,44 C16,28.536027 28.536027,16 44,16 C59.463973,16 72,28.536027 72,44 C72,59.463973 59.463973,72 44,72 Z",
    id: "Path",
    fill: "#AAA7B8",
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBigSearch);
export default __webpack_public_path__ + "static/media/iconBigSearch.92b2b51a.svg";
export { ForwardRef as ReactComponent };